import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsTrafficLightModel {
  id: string;
  access: string;
  pole: string;
  lightbulbType: string;
  operation: string;
  side: string;
  active: string;
  address: string;
  sound: string;
  title: string;
  markerPopupText: string;
  icon: Icon;
}

export class TrafficLightModel extends MarkerModelBase {
  static className = 'TrafficLightModel';
  classProperties: IPropsTrafficLightModel;

  constructor(
    props: IPropsTrafficLightModel,
    geometry: IGeometryModel,
    lat?: number,
    lng?: number
  ) {
    super(geometry, TrafficLightModel.className, lat, lng);
    this.classProperties = props;
  }
}
